import { Column } from "@antv/g2plot";
import get from "lodash/get";

const getlabel = (graphId) => {
  switch (graphId) {
    case 1:
      return {
        style: { fill: "#555555", fontWeight: "600", fontSize: 12 },
        position: "middle",
        rotate: -Math.PI * 0,
      };
    case 2:
    case 3:
    case 4:
    case 5:
      return {
        style: { fill: "#555555", fontWeight: "600", fontSize: 12 },
        position: "top",
        rotate: -Math.PI * 0,
      };
  }
};

///#555555

const getYlabelStyle = (graphId) => {
  switch (graphId) {
    case 1:
      return { fill: "black" };
    case 2:
    case 3:
    case 4:
    case 5:
      return { fill: "black" };
  }
};

const getXlabelStyle = (graphId) => {
  switch (graphId) {
    case 1:
      return { fill: "black" };
    case 2:
    case 3:
    case 4:
    case 5:
      return { fill: "black" };
  }
};

const TestDscription = () => {
  return (
    <div class="bg-gray-50 rounded-lg shadow-md p-4 text-sm text-gray-700 w-64">
      <div class="font-semibold text-gray-600 text-base mb-3 border-b pb-1">
        ${title}
      </div>
      <div class="grid grid-cols-2 gap-y-2 gap-x-4">hello</div>
    </div>
  );
};

const injectionMouldingGetGraphConfig = (
  graphId,
  type,
  meta = {},
) => {
  const isTime =type ==="time";
  
  switch (graphId) {
    case 1:
      return new Column(`graph-${graphId}`, {
        data: [],
        isStack: true,
        legend: false,
        autoFit: true,
        xField: "xAxisLabel",
        yField: "value",
        seriesField: "type",
        padding: "auto",
        renderer: "canvas",
        color: ["#558b2f", "#ff6e40", "#9e9e9e"],
        label: {
          ...getlabel(graphId),
          layout: [
            { type: "interval-adjust-position" },
            { type: "interval-hide-overlap" },
          ],
          formatter: (dataum) => {
            return get(dataum, "value") ? get(dataum, "value") : 0;
          },
        },
        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          type: "cat",
          tickCount: 31,
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: get(datum, "type"),
              value: `${get(datum, "value")} ${
                type === "time" ? "Min" : "Hours"
              }`,
            };
          },
        },
      });
    case 2:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        appendPadding: [20, 0, 0, 0],
        isStack: true,
        legend: false,
        autoFit: true,
        stackField: "type",
        seriesField: "type",
        padding: "auto",
        renderer: "canvas",
        label: {
          ...getlabel(graphId),
          layout: [{ type: "interval-adjust-position" }],
        },
        color: [
          "#2196F3",
          "#AB47BC",
          "#5C6BC0",
          "#42A5F5",
          "#29B6F6",
          "#9e9e9e",
        ],
        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          type: "cat",
          tickCount: 31,
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        tooltip: isTime
          ? {
              customContent: (title, items) => {
                const valString = items
                  .map((item) => {
                    const badgeSvg = `<svg width="8" height="8" style="margin-right: 8px;">
          <circle cx="4" cy="4" r="4" fill="${item.color}" />
        </svg>`;

                    return `
          <div class="flex items-center text-xs font-normal text-gray-700">
            ${badgeSvg}
            <div class="mr-4">${get(item, "data.pc", "--")}: </div>
            <div>${get(item, "value", 0)}</div>
          </div>`;
                  })
                  .join("");
                return `
        <div class="p-3 text-xs">
          <div class="text-gray-800 text-xs mb-2 pb-1">${title}</div>
          <div class="flex flex-col space-y-1">
            ${valString}
          </div>
        </div>`;
              },
            }
          : {
              formatter: (datum) => {
                return {
                  name: "Unit",
                  value: `${get(datum, "value") ? get(datum, "value", 0) : 0}`,
                };
              },
            },
        meta: {
          value: {
            alias: "Count",
          },
        },
      });
    case 3:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        appendPadding: [20, 0, 0, 0],
        color: "#4caf50",
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: "Open Time",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0} Sec`,
            };
          },
        },

        meta: {
          value: {
            alias: "Time",
          },
        },
      });
    case 4:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        appendPadding: [20, 0, 0, 0],
        color: "#ffa000",
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        annotations:
          get(meta, "cycle_time") > 0
            ? [
                {
                  type: "line",
                  start: ["min", get(meta, "cycle_time")], // y = 50
                  end: ["max", get(meta, "cycle_time")],
                  style: {
                    stroke: "#3949ab", // red line
                    lineDash: [4, 4],
                    lineWidth: 2,
                  },
                },
              ]
            : undefined,

        // annotations:undefined,
        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Close Time",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0} Sec`,
            };
          },
        },
        meta: {
          value: {
            alias: "Time",
          },
        },
      });
    case 5:
      return new Column(`graph-${graphId}`, {
        data: [],
        xField: "xAxisLabel",
        yField: "value",
        color: "#455a64",
        appendPadding: [20, 0, 0, 0],
        label: {
          position: "middle", // 'top', 'bottom', 'middle',
          ...getlabel(graphId),
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return {
              name: "Power consumed",
              value: `${get(datum, "value") ? get(datum, "value", 0) : 0} Kwh`,
            };
          },
        },

        yAxis: {
          label: {
            style: getYlabelStyle(graphId),
          },
        },
        xAxis: {
          label: {
            rotate: -Math.PI * 0.45,
            type: "xAxisLabel",
            offset: 40,
            style: getXlabelStyle(graphId),
          },
        },
        meta: {
          value: {
            alias: "Kwh",
          },
        },
      });
  }
};

export default injectionMouldingGetGraphConfig;
